/* import __COLOCATED_TEMPLATE__ from './avatar-group.hbs'; */
/* RESPONSIBLE TEAM: team-frontend-tech */

import templateOnly from '@ember/component/template-only';
const PulseCandidateAvatarGroupComponent = templateOnly();
export default PulseCandidateAvatarGroupComponent;